(function () {
  const DESKTOP_BREAKPOINT = 750;

  const renderBullets = (swiper, current, total) => {
    let out = "";
    for (let i = 1; i < total + 1; i++) {
      const active = i === current ? " swiper-pagination-bullet-active" : "";
      out += `<span class="swiper-pagination-bullet${active}" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
    }
    return out;
  };

  /* ---------- Comparison handles ---------- */

  const bindComparisons = (root) => {
    root.querySelectorAll("[data-ba-card]").forEach((card) => {
      if (card.dataset.baBound === "true") return;
      card.dataset.baBound = "true";

      const range = card.querySelector("[data-ba-range]");
      if (!range) return;

      const apply = () => {
        card.style.setProperty("--ba-pos", `${range.value}%`);
        range.setAttribute("aria-valuetext", `${Math.round(range.value)}% after`);
      };

      range.addEventListener("input", apply);
      apply();

      // Stop a drag on the comparison from also swiping the carousel.
      ["pointerdown", "touchstart", "mousedown"].forEach((type) => {
        range.addEventListener(type, (event) => event.stopPropagation(), {
          passive: true,
        });
      });
    });
  };

  /* ---------- Carousel ---------- */

  const initSlider = (root) => {
    const slider = root.querySelector("[data-ba-slider]");
    if (!slider || slider.swiperInstance || typeof Swiper === "undefined") return;

    const styles = getComputedStyle(root);
    const columns = Number(root.dataset.columns) || 3;
    const columnsMobile = Number(root.dataset.columnsMobile) || 1;
    const gap = parseInt(styles.getPropertyValue("--ba-gap"), 10) || 24;
    const gapMobile = parseInt(styles.getPropertyValue("--ba-gap-mobile"), 10) || 12;
    const slideCount = slider.querySelectorAll(".swiper-slide").length;

    slider.classList.add("swiper");

    const options = {
      loop: root.dataset.loop === "true" && slideCount > columns,
      speed: 600,
      watchOverflow: true,
      slidesPerView: columnsMobile,
      spaceBetween: gapMobile,
      // Dragging the comparison must never scrub the carousel.
      noSwipingClass: "ba-card__range",
      noSwipingSelector: "input[type=range]",
      breakpoints: {
        750: { slidesPerView: Math.min(2, columns), slidesPerGroup: 1, spaceBetween: gap },
        990: { slidesPerView: Math.min(3, columns), slidesPerGroup: 1, spaceBetween: gap },
        1200: { slidesPerView: columns, slidesPerGroup: 1, spaceBetween: gap },
      },
    };

    const pagination = root.querySelector("[data-ba-pagination]");
    if (pagination) {
      options.pagination = {
        el: pagination,
        clickable: true,
        type: "custom",
        renderCustom: renderBullets,
      };
    }

    const prev = root.querySelector("[data-ba-prev]");
    const next = root.querySelector("[data-ba-next]");
    if (prev && next) {
      options.navigation = {
        prevEl: prev,
        nextEl: next,
        disabledClass: "swiper-button-disabled",
        lockClass: "swiper-button-lock",
      };
    }

    slider.swiperInstance = new Swiper(slider, options);
  };

  const destroySlider = (root) => {
    const slider = root.querySelector("[data-ba-slider]");
    if (!slider) return;

    if (slider.swiperInstance) {
      slider.swiperInstance.destroy(true, true);
      slider.swiperInstance = null;
    }
    slider.classList.remove("swiper");
    slider.querySelectorAll(".swiper-slide").forEach((slide) => {
      slide.removeAttribute("style");
    });
  };

  /* ---------- Wiring ---------- */

  const initSection = (section) => {
    if (!section) return;

    section.querySelectorAll("[data-before-after]").forEach((root) => {
      bindComparisons(root);

      const slideDesktop = root.dataset.slideDesktop === "true";

      const observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          const isDesktop = entry.contentRect.width >= DESKTOP_BREAKPOINT;

          if (!isDesktop || slideDesktop) {
            initSlider(root);
          } else {
            destroySlider(root);
          }
        });
      });

      observer.observe(root);
    });
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll("[data-before-after]").forEach(destroySlider);
  });
})();